import { getConfig } from "../../config.js";
import { Module } from "../../lib/ui/Module.js";
import { RemoteService } from "../../lib/data/remote/RemoteService.js";
import { Services } from "../../lib/services/Services.js";

export class WelcomePage extends Module {

    async testRemoteService() {

        const config = getConfig();

        const service = new RemoteService({ baseUrl: config.apiBaseUrl });

        const response = await service.call('GET', '/test');

    }

    _render(vm) {

        const ct = Services.get('templates');
        const page = this;

        return ct.el('div', [
            ct.el('h1', [
                'Welcome!'
            ]),
            ct.p([
                ct.button('Test remote service', 'globe', {
                    onclick: (e) => page.testRemoteService()
                })
            ])
        ]);

    };

}